var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.75a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1M15.25 9.75a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75.875a2.5 2.5 0 0 0-2.5 2.5v1.25h-3.5a1 1 0 0 0 0 2h.5V19.5A1.75 1.75 0 0 0 6 21.25h12a1.75 1.75 0 0 0 1.75-1.75V6.625h.5a1 1 0 1 0 0-2h-3.5v-1.25a2.5 2.5 0 0 0-2.5-2.5zm5 3.75v-1.25a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0-.5.5v1.25zm-8.5 2V19.25h11.5V6.625z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTrash;